// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root___9Obh","inner":"Wrapper_inner__h2DPn"};